import React from "react";
import { VERSION } from "../../constants/version";
import "./index.css";

const CopyRight = () => {
  const [termCondition, setTermCondition] = React.useState(false);
  const [privacyPolicy, setPrivacyPolicy] = React.useState(false);

  return (
    <div className="copyright-wrapper">
      <div className="copyright-left">Copyright © 2026</div>

      <div className="copyright-links">
        <span
          className="label-btn-txt"
          style={{ textDecoration: termCondition ? "underline" : "none" }}
          onClick={() =>
            window.open("/assets/TermsAndConditions.pdf", "_blank")
          }
          onMouseEnter={() => setTermCondition(true)}
          onMouseLeave={() => setTermCondition(false)}
        >
          Terms and Conditions
        </span>

        <div className="copy-right-vertical-line" />

        <span
          className="label-btn-txt"
          style={{ textDecoration: privacyPolicy ? "underline" : "none" }}
          onClick={() => window.open("/assets/PrivacyPolicy.pdf", "_blank")}
          onMouseEnter={() => setPrivacyPolicy(true)}
          onMouseLeave={() => setPrivacyPolicy(false)}
        >
          Privacy Policy
        </span>
      </div>

      <div className="copyright-right">
        <span className="designed-by-container-txt">Powered by</span>
        <span className="designed-by-screen-root-txt">
          {" "}
          Across Assist {VERSION}
        </span>
      </div>
    </div>
  );
};

export default CopyRight;
